export default "__VITE_ASSET__DoA0v_th__"